/**
 * Swap header/footer logos based on the body label class (ex-l-XXXX).
 */
(() => {
  const logoMap = {
    3440: 'https://us.evocdn.io/dealer/1957/content/media/Brands/GOSLogoStandard.jpg', // GOS
    3442: 'https://us.evocdn.io/dealer/1957/content/media/Brands/GOSLogoStandard.jpg', // BR
    3441: 'https://us.evocdn.io/dealer/1957/content/media/Brands/LCOSLogoStandard.png', // LCOS
    3439: 'https://us.evocdn.io/dealer/1957/content/media/Brands/OfficeMartLogoStandard.png', // OM
  };

  const match = [...document.body.classList].find((cls) => /^ex-l-\d+$/.test(cls));
  if (!match) return;

  const labelId = match.replace('ex-l-', '');
  const logoUrl = logoMap[labelId];
  if (!logoUrl) return;

  document.querySelectorAll('header .logo img, footer .logo img').forEach((img) => {
    img.src = logoUrl;
  });
})();
